
import { useState, createContext, useContext } from 'react';
import Sidebar from '../modules/aggregator/pages/Sidebar';
import DashboardHeader from '../modules/aggregator/pages/DashboardHeader';
import LanguageModal from '../modules/aggregator/pages/LanguageModal';
import { Outlet } from 'react-router-dom';

const LanguageModalContext = createContext();

export const useLanguageModal = () => useContext(LanguageModalContext);

const AppLayout = ({ children, userRole }) => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  
  const handleToggleMenu = () => setIsMenuCollapsed(prev => !prev);
  const handleLanguageClick = () => setShowLanguageModal(true);

  return (
    <LanguageModalContext.Provider value={{ showLanguageModal, setShowLanguageModal }}>
      <div className={`app-container ${isMenuCollapsed ? 'menu-collapsed' : ''}`}>
        <Sidebar userRole={userRole}/>
        <main className='right-sidebar' style={{ position: 'relative' }}>
          <DashboardHeader onToggleMenu={handleToggleMenu} onLanguageClick={handleLanguageClick}/>
         {/* <Header /> */}
          <Outlet />
          <LanguageModal showLanguageModal={showLanguageModal} setShowLanguageModal={setShowLanguageModal} />
        </main>
      </div>
    </LanguageModalContext.Provider>
  );
};

export default AppLayout;

